import { ApplicationStatusRoutes } from '../navigation/routes'
import { CardApplicationStatus } from '@acre-rewards/lib'
import { useActiveApplication } from './useActiveApplication'

export function useEnforcedRoute(currentRoute: string) {
  const { activeApplicationStatus } = useActiveApplication()

  const parsedStatus = CardApplicationStatus.safeParse(activeApplicationStatus)

  if (!parsedStatus.success) {
    // If the application status isn't enforced routable, there's no override for routing.
    return null
  }

  // If the application hasn't been submitted yet, there's no override for routing.
  switch (parsedStatus.data) {
    case 'STARTED':
    case 'ADMIN_RESET':
      return null
  }

  if (
    // If the current route is the entry route, there's no override for routing.
    currentRoute === ApplicationStatusRoutes[parsedStatus.data].entryRoute.route ||
    // If the current route is an allowable route, there's no override for routing.
    ApplicationStatusRoutes[parsedStatus.data].allowableRoutes.find(
      (route) => route.route === currentRoute,
    )
  ) {
    return null
  }

  return ApplicationStatusRoutes[parsedStatus.data].entryRoute
}
